import type { ReactNode } from 'react';

import {
  Box,
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import type { DialogProps as MuiDialogProps } from '@mui/material';

import { CloseIcon } from '@shared/ui/icons';

type DialogProps = MuiDialogProps & {
  icon?: ReactNode;
  title?: ReactNode;
  subtitle?: ReactNode;
  buttons?: ReactNode;
};

export const Dialog = (props: DialogProps) => {
  const { icon, title, subtitle, children, buttons, onClose, ...rest } = props;

  return (
    <MuiDialog onClose={onClose} {...rest}>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={2}>
            {icon && (
              <IconButton
                variant="pill"
                size="medium"
                disableRipple
                sx={{ cursor: 'default' }}
              >
                {icon}
              </IconButton>
            )}
            <Box sx={{ flex: 1 }}>
              {title && <Typography fontWeight={600}>{title}</Typography>}
              {subtitle && (
                <Typography variant="body2" color="text.secondary">
                  {subtitle}
                </Typography>
              )}
            </Box>
          </Box>
          <IconButton
            onClick={(event) => onClose?.(event, 'backdropClick')}
            sx={{ alignSelf: 'flex-start' }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {children && <DialogContent>{children}</DialogContent>}

      {buttons && <DialogActions sx={{ gap: 1 }}>{buttons}</DialogActions>}
    </MuiDialog>
  );
};
